export enum SensorType {
  FULL_FRAME = "Full Frame",
  APS_C = "APS-C",
  QUATTRO_TERZI = "Micro 4/3",
  I_1 =  "1\"",
  I_1_23 = "1/2,3\"",
  MEDIO_FORMATO = "Medio Formato",
  I_3_1 = "1/3,1″"
}
